import React, { useEffect, useState } from "react";
import qr from "../../../assests/tenant/images/qr.jpg";
import nodata from "../../../assests/tenant/images/nodata.jpg";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import QRCode from "react-qr-code";
import { useLocation } from "react-router-dom";
import { useFetchPointsScanHistoryMutation } from "../../../features/tenant/rewardify/pointsScanHistory/pointsScanHistoryApi";

const Tracking = () => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const initialRequest = {
    unique_code: "",
    batch_running_code: "",
    limit: 100,
    offset: 0,
  };
  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
    },
    {
      name: "Batch Running Code",
      cell: (row) => row.batch_running_code,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Product Name",
      cell: (row) => row.product_name,
      sortable: true,
    },
    {
      name: "Product Code",
      cell: (row) => row.product_code,
      sortable: true,
    },
    {
      name: "Scanned At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "City",
      cell: (row) => row.city,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Pincode",
      cell: (row) => row.pincode,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "District",
      cell: (row) => row.district,
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "State",
      cell: (row) => row.state,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Address",
      cell: (row) => row.address,
      sortable: true,
      width: "400px",
    },
  ];
  const trackingcolumns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Type",
      cell: (row) => row.type,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Scanned At",
      cell: (row) => row.created_at,
      sortable: true,
    },
    {
      name: "Location",
      cell: (row) => row.location,
      sortable: true,
    },
    {
      name: "User Type",
      cell: (row) => row.user_type,
      sortable: true,
    },
    {
      name: "QR",
      cell: (row) => row.qr_type,
      sortable: true,
    },
    {
      name: "User",
      cell: (row) => row.user_name,
      sortable: true,
    },
    {
      name: "Target User",
      cell: (row) => row.target_user,
      sortable: true,
    },
  ];

  const [request, setRequest] = useState(initialRequest);

  const location = useLocation();

  useEffect(() => {

    if(location.state){
      request["batch_running_code"] = location.state.batch_running_code;
    }

    if (request.batch_running_code !== "") {
      fetchUserQrScanFunction();
    }
  }, [limit, offset , location.state]);

  const [fetchUserQrScan, { data: qrScanData, error: qrScanError }] =
  useFetchPointsScanHistoryMutation();

  const fetchUserQrScanFunction = () => {
    fetchUserQrScan({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  return (
    <div className="flex w-full bg-gray-200 h-full justify-center">
      <div className="w-full ">
        <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
          Tracking
          <LinksComponent />
        </div>

        <div className="p-3">
          <div className=" bg-white shadow rounded-lg p-3">
            <div className="w-full">
              <div className="flex justify-between gap-3 mb-3">
               
                <div className="w-full ">
                  <div className="relative searchin">
                    <input
                      type="search"
                      id="default-search"
                      className="w-full px-2 py-2 h-auto text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Batch Running Code..."
                      required
                      value={request.batch_running_code}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return {
                            ...prevState,
                            batch_running_code: newValue,
                          };
                        });
                      }}
                    />
                  </div>
                </div>
                <button
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-left dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  onClick={(e) => {
                    e.preventDefault();
                    fetchUserQrScanFunction();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
            {qrScanData && qrScanData.body.data&&qrScanData.body.data.length>0 ? (
              <div className="mt-3 ">
                <div className="flex gap-3  mb-3">
                  <div className="border border-gray-200 p-2 flex justify-center items-center w-1/5">
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={`${
                        process.env.REACT_APP_QR_URL
                      }genefied/verifyQr?qrCode=${
                        qrScanData?.body?.data?.length > 0 &&
                        qrScanData?.body?.data[0]?.unique_code
                      }`}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <div className="w-4/5">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                      <tr className="text-sm border border-gray-200 dark:border-gray-700">
                        <th className="text-sm text-left border border-gray-200 uppercase px-2.5 py-2.5 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                          QR ID
                        </th>
                        <td className="text-sm border border-gray-200 uppercase px-2.5 py-2.5 text-gray-900">
                          {qrScanData?.body?.data?.length > 0 &&
                            qrScanData?.body?.data[0]?.qr_id}
                        </td>
                        <th className="text-sm text-left border border-gray-200 uppercase px-2.5 py-2.5 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                          QR
                        </th>
                        <td className="text-sm border border-gray-200 uppercase px-2.5 py-2.5 text-gray-900">
                          {process.env.REACT_APP_QR_URL}
                          genefied/verifyQr?qrCode=
                          {qrScanData?.body?.data?.length > 0 &&
                            qrScanData?.body?.data[0]?.unique_code}
                        </td>
                      </tr>

                      <tr className="text-sm border border-gray-200 dark:border-gray-700">
                        <th className="text-sm text-left border border-gray-200 uppercase px-2.5 py-2.5 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                          GENERATED ON
                        </th>
                        <td className="text-sm border border-gray-200 uppercase px-2.5 py-2.5 text-gray-900">
                          {qrScanData?.body?.data?.length > 0 &&
                            qrScanData?.body?.data[0]?.created_at}
                        </td>
                      </tr>

                      <tr className="text-sm border border-gray-200 dark:border-gray-700">
                        <th className="text-sm text-left border border-gray-200 uppercase px-2.5 py-2.5 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                          PRODUCT NAME
                        </th>
                        <td className="text-sm border border-gray-200 uppercase px-2.5 py-2.5 text-gray-900">
                          {qrScanData?.body?.data?.length > 0 &&
                            qrScanData?.body?.data[0]?.product_name}
                        </td>
                      </tr>

                      <tr className="text-smborder border-gray-200 dark:border-gray-700">
                        <th className="text-sm text-left border border-gray-200 uppercase px-2.5 py-2.5 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                          CATEGORY
                        </th>
                        <td className="text-sm border border-gray-200 uppercase px-2.5 py-2.5 text-gray-900">
                          {qrScanData?.body?.data?.length > 0 &&
                            qrScanData?.body?.data[0]?.category_name}
                        </td>
                      </tr>

                      <tr className="text-smborder border-gray-200 dark:border-gray-700">
                        <th className="text-sm text-left border border-gray-200 uppercase px-2.5 py-2.5 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800">
                          BATCH CODE
                        </th>
                        <td className="text-sm border border-gray-200 uppercase px-2.5 py-2.5 text-gray-900">
                          {qrScanData?.body?.data?.length > 0 &&
                            qrScanData?.body?.data[0]?.batch_code}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div className="p-3 w-full bg-white shadow rounded-lg">
                  <DataTableComponent
              keyField={(row) => row.SNo}
                    columns={columns}
                    // title={""}
                    data={ qrScanData?.body?.data}
                    // loading={loading}
                    totalRows={qrScanData?.body?.total_scans||10}
                    handlePerRowsChange={handlePerRowsChange}
                    handlePageChange={handlePageChange}
                    paginationDefaultPage={currentPage}
                    paginationResetDefaultPage={paginationResetToggle}
                  ></DataTableComponent>
                </div>
              </div>
            ) : (
              <span className="block text-center  text-lg font-bold text-gray-300">
                <img
                  src={nodata}
                  alt=""
                  className="m-auto max-w-full max-h-full"
                />
                No Data Available
              </span>
            )}
            {qrScanData && qrScanData.body.supplybeam&&qrScanData.body.supplybeam.length>0 ? (
              <div className="mt-3 ">
                <div className="p-3 w-full bg-white shadow rounded-lg">
                  <div><h3>Supplychain Tracking</h3></div>
                  <DataTableComponent
              keyField={(row) => row.SNo}
                    columns={trackingcolumns}
                    // title={""}
                    data={qrScanData && qrScanData.body.supplybeam}
                    // loading={loading}
                    totalRows={qrScanData?.body?.supplybeam.length}
                    handlePerRowsChange={handlePerRowsChange}
                    handlePageChange={handlePageChange}
                    paginationDefaultPage={currentPage}
                    paginationResetDefaultPage={paginationResetToggle}
                  ></DataTableComponent>
                </div>
              </div>
            ) : "" }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tracking;
